import { c as _c } from "react/compiler-runtime";
import { usePageView } from '@/analytics/pageTypes';
import { Layout } from '@/components/layout';
import { SeoHeader } from '@/components/SeoHeader';
import { useTranslation } from 'react-i18next';
import type { GetStaticProps } from 'next';
import { getIntlProps, type IntlProps } from '@/utils/intl';
import React, { useState } from 'react';
import HeroSimple from '@/sections/HeroSimple';
import { InsuranceReportForm } from '@/sections/insuranceReport/InsuranceReportForm';
import { isAllowedRoute } from '@/lang/pagesConfig';
import { STEP_SLUGS, type StepSlug } from '@/sections/insuranceReport/InsuranceReportForm.types';
interface Props extends IntlProps {}
export default function Page() {
  const $ = _c(24);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["insuranceReport", "core"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  const [currentStep, setCurrentStep] = useState(STEP_SLUGS.INSURANCE_NUMBER);
  usePageView("insurance-report");
  let t1;
  if ($[1] !== t) {
    t1 = t("seo.title");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t) {
    t2 = t("seo.description");
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <SeoHeader title={t1} description={t2} nofollow={true} noindex={true} />;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t) {
    t4 = t("heroSection.title");
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== currentStep || $[11] !== t) {
    t5 = currentStep !== STEP_SLUGS.RESULT && <p className="mx-auto mt-4 max-w-[48rem] text-base lg:mt-8 lg:text-xl">{t("heroSection.description")}</p>;
    $[10] = currentStep;
    $[11] = t;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t4 || $[14] !== t5) {
    t6 = <HeroSimple title={t4} withoutCharacters={true}>{t5}</HeroSimple>;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== currentStep) {
    t7 = <div className="mx-auto max-w-[48rem] rounded-xl bg-white px-4 py-6 lg:rounded-4xl lg:p-12"><InsuranceReportForm currentStep={currentStep} setCurrentStep={setCurrentStep} /></div>;
    $[16] = currentStep;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t6 || $[19] !== t7) {
    t8 = <div className="bg-blue-50 px-4 pb-14 lg:pb-40">{t6}{t7}</div>;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t3 || $[22] !== t8) {
    t9 = <Layout>{t3}{t8}</Layout>;
    $[21] = t3;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  return t9;
}
export const getStaticProps = (async ctx => {
  const isAllowed = isAllowedRoute('hlaseni-skody');
  if (!isAllowed) {
    return {
      notFound: true
    };
  }
  return {
    props: {
      ...(await getIntlProps(ctx, ['insuranceReport', 'core']))
    }
  };
}) satisfies GetStaticProps<Props>;